import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-input-dialog',
    templateUrl: './input-dialog.component.html'
  })
  export class InputDialogComponent {

    dialogForm: FormGroup;

    constructor(
      @Inject(MAT_DIALOG_DATA) public data,
      public dialogRef: MatDialogRef<InputDialogComponent>,
      private formBuilder: FormBuilder,
    ) {
      this.dialogForm = this.createDialogForm();
    }

    createDialogForm(): FormGroup {
      return this.formBuilder.group({
        name: [''],
        link: ['']
      });
    }

    onConfirm(): void {
      // Close the dialog, return true
      console.log(this.dialogForm.value);
      this.dialogRef.close(this.dialogForm.value);
    }

    onDismiss(): void {
      // Close the dialog, return false
      this.dialogRef.close(false);
    }
    closeDialog() {
      this.dialogRef.close(false);
    }
  }